import { viewActions } from 'actions/actionViewActions';
import { AsyncStatus } from 'utils/asyncStatusHelper';
import { createReducer } from 'utils/reducerUtils';
export const defaultState = {
    asyncStatus: AsyncStatus.INIT
};
// Documentation - https://docs.google.com/document/d/15OzI1IxEHR2aGkNTqMgDyuJqABY9cxmGLwXWQjGxY58/edit?usp=sharing
export default createReducer(viewActions.REQUEST, viewActions.SUCCESS, viewActions.ERROR, defaultState);
